import { useReactiveVar } from '@apollo/client/react/hooks/useReactiveVar'
import { Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import { workspaceSelectedElement } from 'api/graphQL/reactiveVars/element'
import { ProjectElementNodeWithMetadata } from 'api/graphQL/types/projectElement.types'
import { useWorkspace2ActionBarStyles } from 'components/WorkspaceEditor/styles/useWorkspace2ActionBarStyles'
import React, { useMemo } from 'react'
import { formatLocalDateTime } from 'shared/utils/dateUtils'

interface ProjectInfoProps {
    projectName: string
    selectedProjectNode?: ProjectElementNodeWithMetadata | null
}

const ProjectInfo = ({
    projectName,
    selectedProjectNode,
}: ProjectInfoProps) => {
    const { projectTitle, lastSavedLabel } = useWorkspace2ActionBarStyles({
        isOMorSMM: true,
    })

    const { metadata: elementMetadata } = useReactiveVar(
        workspaceSelectedElement
    )

    const lastSavedText = useMemo(() => {
        if (!selectedProjectNode?.isInProject) {
            return ''
        }

        const projectMetadata = selectedProjectNode?.metadata
        const metadata = elementMetadata || projectMetadata
        const modifiedBy = metadata?.modifiedBy?.profileInfo
        const lastUpdated = metadata?.updated

        if (!modifiedBy || !lastUpdated) {
            return ''
        }

        try {
            const formattedDate = formatLocalDateTime(
                new Date(lastUpdated),
                'MMMM DD, yyyy, h:mm a'
            )
            return `LAST SAVED: ${formattedDate} - ${modifiedBy.firstName} ${modifiedBy.lastName}`
        } catch (error) {
            console.error('Failed to format date:', error)
            return ''
        }
    }, [
        selectedProjectNode?.isInProject,
        selectedProjectNode?.metadata,
        elementMetadata,
    ])

    return (
        <>
            <Typography className={projectTitle}>{projectName}</Typography>
            {lastSavedText && (
                <Typography className={lastSavedLabel}>
                    <RefreshIcon fontSize="inherit" />
                    {lastSavedText}
                </Typography>
            )}
        </>
    )
}
export default ProjectInfo
